import { render, staticRenderFns } from "./Ability.vue?vue&type=template&id=c20db2e6&scoped=true&"
import script from "./Ability.vue?vue&type=script&lang=js&"
export * from "./Ability.vue?vue&type=script&lang=js&"
import style0 from "./Ability.vue?vue&type=style&index=0&id=c20db2e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20db2e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
